import React from 'react';

// Label + control + message triple used by every auth form, so the four
// screens report validation identically.
//
// The control is nested inside the <label> rather than linked with htmlFor:
// PrimeReact 6's Password renders its `id` on the wrapper div, not on the
// input, so htmlFor would point at a non-labelable element. Implicit
// labelling reaches the inner input in both InputText and Password.
const AuthField = ({id, label, error, hint, children}) => {

    const describedBy = error ? id + "-error" : (hint ? id + "-hint" : undefined);

    return <div className="auth-ux__field">
        <label className="auth-ux__label">
            <span>{label}</span>
            {React.cloneElement(children, {
                'aria-invalid': error ? true : undefined,
                'aria-describedby': describedBy
            })}
        </label>
        {error && <small className="auth-ux__error" id={id + "-error"} role="alert">{error}</small>}
        {!error && hint && <small className="auth-ux__hint" id={id + "-hint"}>{hint}</small>}
    </div>;
};
export default AuthField;
